import {apiWithToken} from "../../systems/api";
import {API_URL} from "../../systems/globalContant";

export default {
    getListBankAccount: (filter) => apiWithToken.get(API_URL.BANK_ACCOUNT, {params: filter}),
    createBankAccount: (params) => apiWithToken.post(API_URL.BANK_ACCOUNT, params)
}